import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { reportFault, watchForFaults } from "./fault-report";
import { tenantSurface } from "./app-host";
import "./styles.css";
import "./learning-companion.css";

// Before the application renders, so an error thrown on the way up is still heard. A
// build that throws usually throws for everybody, which is the signal worth having.
watchForFaults();

const root = document.getElementById("root");
if (!root) {
  throw new Error("WVCEA Connect could not find the application root.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

const currentTenantSurface = tenantSurface();
const privateTenantSurface = currentTenantSurface !== null && currentTenantSurface !== "public";
if ("serviceWorker" in navigator && import.meta.env.PROD && privateTenantSurface) {
  void navigator.serviceWorker.getRegistrations().then((registrations) =>
    Promise.all(registrations.map((registration) => registration.unregister())));
} else if ("serviceWorker" in navigator && import.meta.env.PROD) {
  void navigator.serviceWorker.register("/sw.js").catch((error: unknown) => {
    console.warn("WVCEA Connect could not register offline support.", error);
    // A device without this has no schedule when the signal goes. Worth knowing about
    // quietly rather than finding out in a hallway with no bars.
    reportFault("service_worker_failed", error instanceof Error ? error.message : null);
  });
}
